import React from 'react'
import { UpdateReportAdTypes } from '../../util/contstants'
import { SmartBidSettingBadge } from '../SmartBidSettingsBadge'
import { AdGroupName } from './AdGroupName'
import { CampaignOrAdGroupBadges } from './CampaignOrAdGroupBadges'

export class RenderAdGroupName extends React.PureComponent<any> {
    render() {
        const {
            data,
            screenshotMode = false,
            mutateItems,
            showSmartBidSettings = true,
            fill,
            recipe_version,
        } = this.props

        let smartBids = showSmartBidSettings
        if (recipe_version === 2) {
            smartBids = false
        }

        // `data` can be null when an ad group relation is missing — e.g. a
        // performance row in the negative-keyword modal whose ad group no
        // longer exists (orphaned ad_group_id). Render a placeholder instead
        // of crashing on `data.ad_group_id`.
        if (!data) {
            return <span className="text-gray-400">—</span>
        }

        return (
            <div className="flex min-w-0 w-full items-center overflow-hidden">
                {smartBids && (
                    <SmartBidSettingBadge
                        className="mr-3"
                        parent_id={data.ad_group_id}
                        parent_type={UpdateReportAdTypes.AdGroups}
                        active={
                            data?.smart_bid_setting?.length ? data.smart_bid_setting[0].id : false
                        }
                        mutateItems={mutateItems}
                    />
                )}
                <div className="flex min-w-0 flex-1 items-center overflow-hidden">
                    <CampaignOrAdGroupBadges data={data} />
                    <AdGroupName
                        showState={false}
                        adGroup={data}
                        screenshotMode={screenshotMode}
                        fill={fill}
                    />
                </div>
            </div>
        )
    }
}
